/* eslint-disable max-lines */ const $d336989ff0a4095d$export$8f45430ccf837300 = {
    "text-primary": `#21282B`,
    "text-secondary": `#5A5E60`,
    "text-minor": `#919395`,
    "text-invert": `#FFFFFF`,
    "text-primary-invert": `#FFFFFF`,
    "text-secondary-invert": `#FFFFFFBF`,
    "text-minor-invert": `#FFFFFF80`,
    "background-primary": `#FFFFFF`,
    "background-secondary": `#F5F4F1`,
    "background-accent": `#21282B`,
    "control-primary": `#21282B`,
    "control-secondary": `#CCC6B8`,
    "control-accent": `#FDC300`,
    "control-minor": `#E3E1D8`,
    "control-invert": `#FFFFFF`,
    "control-primary-invert": `#FFFFFF`,
    "control-secondary-invert": `#FFFFFF80`,
    "control-minor-invert": `#FFFFFF40`,
    "control-hover-primary": `#000000`,
    "control-hover-secondary": `#B2A994`,
    "control-hover-accent": `#DFA000`,
    "control-hover-minor": `#CCC6B8`,
    "control-hover-primary-invert": `#FFFFFFBF`,
    "control-hover-secondary-invert": `#FFFFFF99`,
    "control-hover-minor-invert": `#FFFFFF80`,
    "success-primary": `#49A941`,
    "success-dark": `#357931`,
    "success-light": `#C4ECC1`,
    "brand-primary": `#FDC300`,
    "brand-dark": `#BF8900`,
    "brand-light": `#F9E28D`,
    "brand-minor": `#21282B`,
    "brand-secondary": `#21282B`,
    "brand-invert": `#FFFFFF`,
    "accent-primary": `#FFE55A`,
    "accent-dark": `#B09D37`,
    "accent-light": `#FCF2BE`,
    "attention-primary": `#C85952`,
    "attention-dark": `#9C4944`,
    "attention-light": `#F0DAD8`,
    "b2b-primary": `#A36A47`,
    "b2b-dark": `#863914`,
    "b2b-light": `#DFCDC0`,
    "b2b-accent": `#21282B`,
    "secondary-green-primary": `#A0B9B1`,
    "secondary-green-dark": `#6A8C81`,
    "secondary-green-light": `#D0DDD8`,
    "secondary-blue-primary": `#3D6BE3`,
    "secondary-blue-dark": `#3B59A4`,
    "secondary-blue-light": `#D1DEFF`,
    "secondary-orange-primary": `#D95E00`,
    "secondary-orange-dark": `#AD4B00`,
    "secondary-orange-light": `#F7DECC`,
    "secondary-purple-primary": `#89527D`,
    "secondary-purple-dark": `#6E1454`,
    "secondary-purple-light": `#D7C5D3`,
    "secondary-yellow-primary": `#FFED00`,
    "secondary-yellow-dark": `#A49D41`,
    "secondary-yellow-light": `#FFF572`,
    "secondary-red-primary": `#B82825`,
    "secondary-red-dark": `#801916`,
    "secondary-red-light": `#E7CAC8`,
    "secondary-black": `#000000`,
    "secondary-white": `#FFFFFF`,
    "service-primary": `#1CAFD4`,
    "service-dark": `#0D5263`,
    "service-light": `#C2EAF3`
};
const $d336989ff0a4095d$export$1834e0062fdb50b3 = {
    "control-invert_opacity-4": `#FFFFFF66`,
    "success-light_opacity-4": `#C4ECC166`
};
const $d336989ff0a4095d$export$136fd86de524d3c2 = {
    "bg-disable-primary": `linear-gradient( 135deg, ${$d336989ff0a4095d$export$1834e0062fdb50b3["control-invert_opacity-4"]} 21.43%, rgba(0,0,0,0) 21.43%, rgba(0,0,0,0) 50%, ${$d336989ff0a4095d$export$1834e0062fdb50b3["control-invert_opacity-4"]} 50%, ${$d336989ff0a4095d$export$1834e0062fdb50b3["control-invert_opacity-4"]} 71.43%, rgba(0,0,0,0) 71.43%, rgba(0,0,0,0) 100% ) center / 7px 7px, ${$d336989ff0a4095d$export$8f45430ccf837300["control-primary"]}`,
    "bg-disable-secondary": `linear-gradient( 135deg, ${$d336989ff0a4095d$export$8f45430ccf837300["control-invert"]} 21.43%, rgba(0,0,0,0) 21.43%, rgba(0,0,0,0) 50%, ${$d336989ff0a4095d$export$8f45430ccf837300["control-invert"]} 50%, ${$d336989ff0a4095d$export$8f45430ccf837300["control-invert"]} 71.43%, rgba(0,0,0,0) 71.43%, rgba(0,0,0,0) 100% ) center / 7px 7px, ${$d336989ff0a4095d$export$8f45430ccf837300["control-secondary"]}`,
    "bg-disable-minor": `linear-gradient( 135deg, ${$d336989ff0a4095d$export$8f45430ccf837300["control-invert"]} 21.43%, rgba(0,0,0,0) 21.43%, rgba(0,0,0,0) 50%, ${$d336989ff0a4095d$export$8f45430ccf837300["control-invert"]} 50%, ${$d336989ff0a4095d$export$8f45430ccf837300["control-invert"]} 71.43%, rgba(0,0,0,0) 71.43%, rgba(0,0,0,0) 100% ) center / 7px 7px, ${$d336989ff0a4095d$export$8f45430ccf837300["control-minor"]}`,
    "bg-disable-accent": `linear-gradient( 135deg, ${$d336989ff0a4095d$export$1834e0062fdb50b3["success-light_opacity-4"]} 21.43%, rgba(0,0,0,0) 21.43%, rgba(0,0,0,0) 50%, ${$d336989ff0a4095d$export$1834e0062fdb50b3["success-light_opacity-4"]} 50%, ${$d336989ff0a4095d$export$1834e0062fdb50b3["success-light_opacity-4"]} 71.43%, rgba(0,0,0,0) 71.43%, rgba(0,0,0,0) 100% ) center / 7px 7px, ${$d336989ff0a4095d$export$8f45430ccf837300["success-primary"]}`,
    "bg-disable-alert": `linear-gradient( 135deg, ${$d336989ff0a4095d$export$1834e0062fdb50b3["control-invert_opacity-4"]} 21.43%, rgba(0,0,0,0) 21.43%, rgba(0,0,0,0) 50%, ${$d336989ff0a4095d$export$1834e0062fdb50b3["control-invert_opacity-4"]} 50%, ${$d336989ff0a4095d$export$1834e0062fdb50b3["control-invert_opacity-4"]} 71.43%, rgba(0,0,0,0) 71.43%, rgba(0,0,0,0) 100% ) center / 7px 7px, ${$d336989ff0a4095d$export$8f45430ccf837300["attention-primary"]}`
};
const $d336989ff0a4095d$export$f45fbea8fe20ca8a = {
    "font-base": `Roboto, apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif`
};
const $d336989ff0a4095d$export$da6c1b172b339805 = {
    "opacity-4": `0.4`,
    "opacity-6": `0.6`,
    "opacity-8": `0.8`
};
const $d336989ff0a4095d$export$569a051bea7a731f = {
    "rounding-m": `4px`,
    "rounding-l": `8px`,
    "rounding-xl": `16px`
};
const $d336989ff0a4095d$export$3eb26d38a832ce9a = {
    "box-shadow-m": `
  0 1.17px 2px rgba(0, 0, 0, 0.0196802),
  0 1.4px 5px rgba(0, 0, 0, 0.03),
  0 2px 10px rgba(0, 0, 0, 0.03),
  0 2px 18px rgba(0, 0, 0, 0.04),
  0 9px 33px rgba(0, 0, 0, 0.03),
`,
    "box-shadow-m-up": `
  0 -1.17px 2px rgba(0, 0, 0, 0.0196802),
  0 -1.4px 5px rgba(0, 0, 0, 0.03),
  0 -2px 10px rgba(0, 0, 0, 0.03),
  0 -2px 18px rgba(0, 0, 0, 0.04),
  0 -9px 33px rgba(0, 0, 0, 0.03),
`,
    "box-shadow-s": `
  0 1px 4px rgba(0, 0, 0, 0.16),
  0 2px 9px rgba(0, 0, 0, 0.02),
`,
    "box-shadow-s-up": `
  0 -1px 4px rgba(0, 0, 0, 0.16),
  0 -2px 9px rgba(0, 0, 0, 0.02),
`,
    "box-shadow-l": `
  0 0.166035px 2.21381px rgba(0, 0, 0, 0.0196802),
  0 0.399006px 5.32008px rgba(0, 0, 0, 0.0282725),
  0 0.751293px 10.0172px rgba(0, 0, 0, 0.035),
  0 12px 40px rgba(0, 0, 0, 0.08),
`,
    "box-shadow-l-up": `
  0 -0.166035px 2.21381px rgba(0, 0, 0, 0.0196802),
  0 -0.399006px 5.32008px rgba(0, 0, 0, 0.0282725),
  0 -0.751293px 10.0172px rgba(0, 0, 0, 0.035),
  0 -12px 40px rgba(0, 0, 0, 0.08),
`
};
const $d336989ff0a4095d$export$4baaf6dabb0fdd38 = {
    "space-10": `1px`,
    "space-25": `2px`,
    "space-35": `3px`,
    "space-50": `4px`,
    "space-60": `5px`,
    "space-75": `6px`,
    "space-85": `7px`,
    "space-100": `8px`,
    "space-125": `10px`,
    "space-150": `12px`,
    "space-175": `14px`,
    "space-200": `16px`,
    "space-225": `18px`,
    "space-250": `20px`,
    "space-275": `22px`,
    "space-300": `24px`,
    "space-325": `26px`,
    "space-350": `28px`,
    "space-375": `30px`,
    "space-400": `32px`,
    "space-425": `34px`,
    "space-450": `36px`,
    "space-475": `38px`,
    "space-500": `40px`,
    "space-525": `42px`,
    "space-550": `44px`,
    "space-575": `46px`,
    "space-600": `48px`,
    "space-625": `50px`,
    "space-650": `52px`,
    "space-675": `54px`,
    "space-700": `56px`,
    "space-725": `58px`,
    "space-750": `60px`,
    "space-775": `62px`,
    "space-800": `64px`,
    "space-825": `66px`,
    "space-850": `68px`,
    "space-875": `70px`,
    "space-900": `72px`,
    "space-925": `74px`,
    "space-950": `76px`,
    "space-975": `78px`,
    "space-1000": `80px`
};




export {$d336989ff0a4095d$export$f45fbea8fe20ca8a as fonts, $d336989ff0a4095d$export$3eb26d38a832ce9a as shadows, $d336989ff0a4095d$export$8f45430ccf837300 as colors, $d336989ff0a4095d$export$1834e0062fdb50b3 as opacityColors, $d336989ff0a4095d$export$da6c1b172b339805 as opacities, $d336989ff0a4095d$export$4baaf6dabb0fdd38 as spacings, $d336989ff0a4095d$export$569a051bea7a731f as roundings};
